import { render, staticRenderFns } from "./carOrder.vue?vue&type=template&id=8405037a&scoped=true&"
import script from "./carOrder.vue?vue&type=script&lang=js&"
export * from "./carOrder.vue?vue&type=script&lang=js&"
import style0 from "./carOrder.vue?vue&type=style&index=0&id=8405037a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8405037a",
  null
  
)

export default component.exports